import { render, staticRenderFns } from "./baseAirplaneModel.vue?vue&type=template&id=387c619e&"
import script from "./baseAirplaneModel.vue?vue&type=script&lang=js&"
export * from "./baseAirplaneModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('387c619e')) {
      api.createRecord('387c619e', component.options)
    } else {
      api.reload('387c619e', component.options)
    }
    module.hot.accept("./baseAirplaneModel.vue?vue&type=template&id=387c619e&", function () {
      api.rerender('387c619e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/baseAirplaneModel.vue"
export default component.exports